import { DownOutlined, RightOutlined } from '@ant-design/icons'
import { Text } from 'designSystem/components/Text'
import React from 'react'
import styled from 'styled-components'

const Header = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${(props) => props.theme.forecast.defaultText};
  flex-shrink: 0;

  &:hover {
    background-color: ${(props) => props.theme.forecast.hoverButton};
  }
`

interface CollapsibleSectionHeaderProps {
  label: string
  count: number | string
  isExpanded: boolean
  onToggle: () => void
}

export const CollapsibleSectionHeader: React.FC<
  CollapsibleSectionHeaderProps
> = ({ label, count, isExpanded, onToggle }) => {
  return (
    <Header onClick={onToggle}>
      {isExpanded ? (
        <DownOutlined style={{ fontSize: '0.625rem' }} />
      ) : (
        <RightOutlined style={{ fontSize: '0.625rem' }} />
      )}
      {label}
      <Text as='span' weight='normal' color='muted'>
        ({count})
      </Text>
    </Header>
  )
}
